import React, {ReactNode} from 'react'
import classNames from 'classnames'

import styles from './BannerSection.module.scss'

interface IBannerSectionProps {
  id?: string
  className?: string
  children: ReactNode
}

const BannerSection = ({id, className, children}: IBannerSectionProps) => (
  <div id={id} className={classNames(styles.section, className)}>
    {children}
  </div>
)

export default BannerSection
